/**
 * Upload-related handlers
 */

import type { ObjectType } from '../../../../../map-editor-shared/store/objectTypeStore'
import type { EditorModalState } from '../types'

export function handleUploadClickFn(params: {
  types: ObjectType[]
  setModalState: React.Dispatch<React.SetStateAction<EditorModalState>>
  triggerFileUpload: () => void
}) {
  const { types, setModalState, triggerFileUpload } = params

  if (types.length === 0) {
    setModalState((prev) => ({ ...prev, noTypes: true }))
    return
  }
  triggerFileUpload()
}
